import _store from "store2";

import {ElMessage} from "element-plus";
import {
    aiDetailedit, closeAI,
    createSession,
    deleteChatDetail, deleteChatDetailAll,
    getChatDetailList,
    getRootData,
    queryChatById,
    sendSSE, updateSession
} from "@/api/ai";

const AIStore = {
    namespaced: true,
    state: {
        chatContentArray: [],
        chatContentArrayMail: [],
        // 最新的对话 root
        currentLastNewChat: {},
        //     对话详情列表
        chatDetailList: [],
        chatDetailListSetting: {
            pageNo: 1,
            pageSize: 30,
            total: 0,
        },
        hasMore: true,
        //   指定对话详情
        currentTargetChat: [],
        currentTargetSetting: {
            pageNo: 1,
            pageSize: 999999,
            total: 0,
        },
        currentTargetChatMail: [],
        currentTargetSettingMail: {
            pageNo: 1,
            pageSize: 999999,
            total: 0,
        },
        //     会话 id
        associateId: "",
        // 邮件助手 会话 id
        associateIdMail: "",
        chatDetailListParent: [],
        chatDetailListSettingParent: {
            pageNo: 1,
            pageSize: 1,
            total: 0,
        },
        chatDetailListParentMail: [],
        chatDetailListSettingParentMail: {
            pageNo: 1,
            pageSize: 1,
            total: 0,
        },
        //  分页数据
        currentPage: 1,
        currentPageMail: 1,
    },
    getters: {},
    mutations: {
        setCurrentPage(state, payload) {
            state.currentPage = payload
        },
        setCurrentPageMail(state, payload) {
            state.currentPageMail = payload
        },
        setCurrentTargetSetting(state, payload) {
            const {type, value} = payload
            state.currentTargetSetting[type] = value
        },
        setAssociateId(state, payload) {
            state.associateId = payload
        },
        setAssociateIdMail(state, payload) {
            state.associateIdMail = payload
        },
        setChatContentArray(state, payload) {
            state.chatContentArray = payload
        },
        setChatContentArrayMail(state, payload) {
            state.chatContentArrayMail = payload
        },
        setChatDetailListSettingParent(state, payload) {
            const {type, value} = payload
            state.chatDetailListSettingParent[type] = value
        },
        setChatDetailListSettingParentMail(state, payload) {
            const {type, value} = payload
            state.chatDetailListSettingParentMail[type] = value
        },
        setChatDetailListSetting(state, payload) {
            const {type, value} = payload
            state.chatDetailListSetting[type] = value
        },
        setHasMore(state, payload) {
            state.hasMore = payload
        }
    },
    actions: {
        //     获取对话详情列表
        async getChatDetailListApis({state}, payload) {
            const res = await getChatDetailList({...state.chatDetailListSetting,type:1})
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
            state.chatDetailList = res.result.records
            state.chatDetailListSetting.pageNo = res.result.current;
            state.chatDetailListSetting.pageSize = res.result.size
            state.chatDetailListSetting.total = res.result.total
        },
        // 获取指定对话 列表 parentid
        async getChatDetailListApisParent({state}, payload) {
            const res = await queryChatById({
                associateId: state.associateId,
                ...state.chatDetailListSettingParent,
                ...payload
            })
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
            state.chatDetailListParent = res.result.records
            state.chatDetailListSettingParent.pageNo = res.result.current + 1;
            state.chatDetailListSettingParent.pageSize = res.result.size
            state.chatDetailListSettingParent.total = res.result.total
        },
        async getChatDetailListApisParentMail({state}, payload) {
            console.log('associateIdMailassociateIdMail')
            const res = await queryChatById({
                associateId: state.associateIdMail,
                ...state.chatDetailListSettingParentMail,
                ...payload
            })
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
            state.chatDetailListParentMail = res.result.records
            state.chatDetailListSettingParentMail.pageNo = res.result.current + 1;
            state.chatDetailListSettingParentMail.pageSize = res.result.size
            state.chatDetailListSettingParentMail.total = res.result.total
        },

        //    删除指定对话详情
        async deleteChatDetailApis({state}, payload) {
            const res = await deleteChatDetail(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
            ElMessage.success(res.message);
        },
        // 删除所有历史记录
        async deleteAllChatDetail({state}, payload) {
            const res = await deleteChatDetailAll()
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
            ElMessage.success(res.message);
        },
        //     对话详情
        async queryChatByIdApis({state}, payload) {
            const {pageNo, pageSize} = state.currentTargetSetting
            const res = await queryChatById({...payload, pageNo, pageSize,})
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
            state.currentTargetChat = res.result.records
            state.currentTargetSetting.pageNo = res.result.current;
            state.currentTargetSetting.pageSize = res.result.size
        },
        async queryChatByIdApisMail({state}, payload) {
            const {pageNo, pageSize} = state.currentTargetSettingMail
            const res = await queryChatById({...payload, pageNo, pageSize,})
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
            state.currentTargetChatMail = res.result.records
            state.currentTargetSettingMail.pageNo = res.result.current;
            state.currentTargetSettingMail.pageSize = res.result.size
        },
        //建立会话 - 智能助手
        async createSessionApis({state}, payload = {}) {
            const res = await createSession({ ...payload, type: 1 })
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
            state.associateId = res.result
        },
        // 邮件助手建立会话
        async createSessionApisMail({state}, payload = {}) {
            const res = await createSession({ ...payload, type: 2 })
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
            state.associateIdMail = res.result
        },
        //     数据流
        async sendSSEApis({state}, payload) {
            const res = await sendSSE(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
        },
        // 修改 ai 生成的内容
        async aiDetaileditApis({state}, payload) {
            const res = await aiDetailedit(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
        },
        //     获取根节点的信息
        async getRootDataApis({state}, payload) {
            const res = await getRootData(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
            console.log(res, 'root')
            state.currentLastNewChat = res.result
        },

        async getRootDataApisMail({state}, payload) {
            const res = await getRootData(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
            console.log(res, 'root')
            state.currentLastNewChatMail = res.result
        },
        //     关闭ai 对话
        async closeAIApis({state}, payload) {
            const res = await closeAI(payload)
            // if (res.code !== 200) {
            //     ElMessage.error(res.message)
            //     return
            // }
            // ElMessage.success(res.message)
        },
        async updateSessionApis({state}, payload) {
            const res = await updateSession()
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
        }
    },
};

export default AIStore;
